<div>
  <div class="db-cdn-disabled">
    <div>

      <div class="db-cdn-header" *ngIf="!currentSubscription?.trialBoosterClient">
        <div>
          <h4><img src="assets/images/icons/cloudflare-big.svg" alt=""><span
            [innerHTML]="currentSubscription?.platformPaidClient || currentSubscription?.trialClient ?
            ('text_cloudflare-enterprise' | dbText) + ' add-on':
            'text_cloudflare-enterprise' | dbText"></span></h4>
          <p *ngIf="!currentSubscription?.trialClient && canEnable && !currentSubscription?.trialBoosterClient && !currentSubscription?.boosterProClient"><span class="mb15" [innerHTML]="'text_cdnDescription' | dbText"></span></p>
          <p *ngIf="currentSubscription?.trialBoosterClient"><span class="mb15" [innerHTML]="(currentSubscription?.boosterProClient ? 'text_cdnDescriptionPro' : 'text_cdnDescriptionFree') | dbText"></span></p>
        </div>
        <p class="db-content-desc mt15" *ngIf="!currentSubscription?.trialBoosterClient &&
        !currentSubscription?.boosterProClient && !(currentSubscription?.platformPaidClient && !!website?.domain_hash)"><span [innerHTML]="'text_cdnContent' | dbText"></span></p>
      </div>

      <ng-container [ngTemplateOutlet]="trialBoosterCase" *ngIf="currentSubscription?.trialBoosterClient">
      </ng-container>

      <ng-container [ngTemplateOutlet]="hostedPaidCase" *ngIf="(!!website?.domain_hash || (currentSubscription?.platformPaidClient &&
      website?.connectedFrom === 'speed_optimizer')) && !currentSubscription?.trialClient">
      </ng-container>

      <ng-container [ngTemplateOutlet]="platformTrialCase" *ngIf="currentSubscription?.trialClient &&
      (!!website?.domain_hash || website?.connectedFrom === 'speed_optimizer')">
      </ng-container>

      <ng-container [ngTemplateOutlet]="boosterProCase" *ngIf="currentSubscription?.boosterProClient && !website?.domain_hash">
      </ng-container>

      <hr class="divider mt25 mb25" *ngIf="!currentSubscription?.trialBoosterClient && !currentSubscription?.boosterProClient && !currentSubscription?.platformPaidClient">
      <div class="db-booster-free-interface" *ngIf="currentSubscription?.boosterProClient || currentSubscription?.platformPaidClient">
        <hr class="divider mt40">
        <span [innerHTML]="(currentSubscription?.trialBoosterClient ? 'text_cdnBenefitsTitleFree' : 'text_cdnBenefitsTitle') | dbText"></span>
        <p class="db-content-desc mt35 mb25" [ngClass]="{'left': currentSubscription?.trialBoosterClient}"><span
          [innerHTML]="(currentSubscription?.trialBoosterClient ?
        'text_cdnContentFree' : 'text_cdnContent') | dbText"></span></p>
      </div>

      <div class="db-cdn-features">
        <h5 class="db-cdn-features-header" *ngIf="!currentSubscription?.trialBoosterClient && !currentSubscription?.boosterProClient && !currentSubscription?.platformPaidClient"><span>Included in all pro plans:</span></h5>
        <div class="db-cdn-features-items" *ngIf="!currentSubscription?.trialBoosterClient">
          <div *ngFor="let feature of features">
            <h5 class="mb4" [innerHTML]="feature.title"></h5>
            <p [innerHTML]="feature.desc"></p>
            <i class="db-icon db-icon-ds-checkmark-bg"></i>
          </div>
        </div>
<!--        <ng-container [ngTemplateOutlet]="trialBoosterFeatures" *ngIf="currentSubscription?.trialBoosterClient">
        </ng-container>-->
      </div>

    </div>

  </div>
</div>

<ng-template #trialBoosterFeatures>
  <div class="db-cdn-features-booster-free">
    <div *ngFor="let feature of features; let i=index" [ngClass]="{'toggled': showDesc}">
        <div (click)="toggleArrow(i)">
          <img class="mr12" src="{{feature?.img}}"/>
          <span class="mb4" [innerHTML]="feature.title"></span>
          <i class="db-icon db-icon-ds-arrow-small" [ngClass]="{'toggled':showDesc === i }"></i>
        </div>
      <div class="db-desc ml30" *ngIf="showDesc === i" [ngClass]="{'toggled': showDesc === i}">
       <p class="ml17" [innerHTML]="feature.desc"></p>
      </div>
    </div>
  </div>
  <div class="db-cdn-features-footer mt25">
    <p><span
      [innerHTML]="'text_boosterFreeFeaturesUpgrade' | dbText"></span></p>
    <a class="ds-btn-green" (click)="upgrade()">
      <span *ngIf="!loadingApply">{{(showPercentOffer ? 'text_upgrade' : 'text_tryForFree') | dbText | lowerCaseSpecificWords}}</span>
    </a>
  </div>
</ng-template>

<ng-template #trialBoosterCase>
    <db-cdn-test [currentSubscription]="currentSubscription"></db-cdn-test>
</ng-template>

<ng-template #boosterProCase>
  <div class="db-booster-pro-footer mt27" [ngClass]="{'db-disable': !hasSslCertificate}">
    <div>
      <div class="db-pro-optim-section-options" *ngIf="currentSubscription.boosterProClient">
        <div class="db-pro-optim-section-option" *ngFor="let option of options">
          <div class="db-pro-optim-section-option-text" [innerHTML]="option.text"></div>
          <img src="{{option.img}}"/>
        </div>
      </div>
      <div class="db-message-wrap mt23" [ngClass]="{'without-notice': hasSslCertificate}">
        <div class="ds-notification-warning" *ngIf="!hasSslCertificate">
          <div>
            <i class="db-icon db-icon-ds-info-bg"></i>
            <p><span [innerHTML]="'text_cdnSSLIsMissing' | dbText"></span></p>
          </div>
        </div>
        <div class="db-cdn__enable-pro">
<!--          <a class="ds-btn-green" [ngClass]="{'ds-btn-disabled': !hasSslCertificate}" (click)="enable()">
            <span *ngIf="!loadingApply">enable</span>
          </a>-->
          <a class="ds-btn-green" [ngClass]="{'ds-btn-disabled': (!hasSslCertificate || !!loadingApply || (!canEnable && currentSubscription?.recharge))}"
             (click)="!!canEnable ? enable() : buyNow()">
            <span *ngIf="!loadingApply">{{!!canEnable ?  'Enable' : 'Buy Now'}}</span>
            <span class="ds-spinner-circle"  *ngIf="!!loadingApply"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #platformTrialCase>
  <div class="db-cdn__enable mt27">
    <div class="db-buy-now">
      <h4>
        <span [innerHTML]="('text_buyNowCdnTrial' | dbText)"></span>
      </h4>
    </div>
    <a class="ds-btn-green"
       (click)="buyNow()">
      <span>{{'buy now' | lowerCaseSpecificWords}}</span>
    </a>
  </div>
</ng-template>


<ng-template #hostedPaidCase>
  <div class="db-pro-optim-section-options mt30" *ngIf="!!website?.domain_hash">
    <div class="db-pro-optim-section-option" *ngFor="let option of options">
      <div class="db-pro-optim-section-option-text" [innerHTML]="option.text"></div>
      <img src="{{option.img}}"/>
    </div>
  </div>
  <div class="db-cdn__enable mt27">
    <div class="db-buy-now" *ngIf="!canEnable">
      <h4>
        <span [innerHTML]="'text_buyNowCdnPlatform' | dbText: {parameterPrice: currentSubscription?.plan?.cdnCountPrice / (currentSubscription?.plan?.periodNumber > 1 ? 12 : 1)}"></span>
      </h4>
    </div>
    <div class='db-enable-website-link' *ngIf="!!hasSslCertificate && primaryChanged && currentSubscription?.plan?.additionalCDNCount >= 1 && canEnable">
      <h4>
        <span>Enable Cloudflare Enterprise for</span>
      </h4>
      <a target="_blank" rel="noopener" href="{{website?.site_url}}"><span
        class="db-website-link">{{siteUrl}}</span></a>
    </div>
    <div class="ds-notification-warning" *ngIf="!!canEnable && (!hasSslCertificate || !primaryChanged)">
      <div>
        <i class="db-icon db-icon-ds-info-bg"></i>
        <p *ngIf="!hasSslCertificate && !!primaryChanged && !!website?.domain_hash"><span
          [innerHTML]="'text_cdnSSLIsMissingHosted'|
        dbText"></span><a
          class="text-underline" (click)="redirect('hosting/tools')">activate an SSL</a> certificate on your domain to continue.</p>
        <p *ngIf="website?.connectedFrom === 'speed_optimizer' && !hasSslCertificate"><span
          [innerHTML]="'text_cdnSSLIsMissing' | dbText"></span></p>
        <p *ngIf="!primaryChanged && !!website?.domain_hash"><span
          [innerHTML]="'text_domainChangedCdn'| dbText"></span><a class="text-underline"
         (click)="redirect('domains')">complete that step before proceeding.</a></p>
      </div>
    </div>
  <a class="ds-btn-green" *ngIf="!isMember" [ngClass]="{'ds-btn-disabled': (!!canEnable && (!hasSslCertificate || !primaryChanged || !!loadingApply)) || (!canEnable && currentSubscription?.recharge)}"
       (click)="!!canEnable ? enable() : buyNow()">
      <span *ngIf="!loadingApply">{{(canEnable ?  'enable' : 'buy now') | lowerCaseSpecificWords}}</span>
      <span class="ds-spinner-circle"  *ngIf="!!loadingApply"></span>
    </a>
    <span *ngIf="isMember" class="db-ask-owner">To use this feature,<br/> please contact the workspace owner</span>
  </div>
</ng-template>
